import { css, CSSResult } from 'lit'

export const style: CSSResult = css`
  .csc-image-hotspot {
    position: relative;
    display: inline-block;
    width: 100%;
  }
`

export const targetStyle: CSSResult = css`
  .target {
    position: absolute;
    z-index: 1;
    transform: translate(-50%, -50%);
  }
`
